import React from 'react';
import { Box, Button, CardMedia, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InspectionYoutube from './Youtube/InspectionYoutube';

function InspectCarBanner() {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          color: '#fff',
          pt: 5,
          pb: 25,
          px: 6,
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        {/* Focus */}
        <Typography
          variant="subtitle2"
          sx={{
            background: 'linear-gradient(to right, #EA5D16, #F6851F)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: 28,
            letterSpacing: 1,
          }}
        >
          Focus
        </Typography>

        {/* Badge + Inspect text wrapper */}
        <Box sx={{ position: 'relative', mt: 1, width: 'fit-content' }}>
          {/* Emblem Label Badge */}
          <Box
            sx={{
              color: '#000',
              borderRadius: '50%',
              width: 104,
              height: 68,
              position: 'absolute',
              top: '-32px',
              right: '-81px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              transform: 'rotate(-3deg)',
            }}
          >
            <CardMedia
              component="img"
              src="assets/images/Inspection/seal.png"
              alt="Card Image"
              sx={{ objectFit: 'contain', borderRadius: '10px' }}
            />
          </Box>

          {/* Inspect any car */}
          <Typography
            sx={{
              fontWeight: 600,
              color: '#FFFEFD',
              lineHeight: 1,
              fontSize: 40,
            }}
          >
            Inspect <br /> any car
          </Typography>
        </Box>

        {/* you’re going to buy! */}
        <Typography
          variant="subtitle1"
          sx={{
            background: 'linear-gradient(to right, #EA5D16, #F6851F)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: 28,
            fontWeight: 600,
          }}
        >
          you’re going
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            background: 'linear-gradient(to right, #EA5D16, #F6851F)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: 28,
            fontWeight: 600,
          }}
        >
          to buy!
        </Typography>
      </Box>

      <Stack
        sx={{
          px: 2,
          py: 0,
          backgroundColor: 'white',
        }}
      >
        <Box sx={{ margin: '-120px 0px 10px' }}>
          <InspectionYoutube youtubeId="RGBhSS6JtGQ" />
        </Box>
        <Box sx={{ width: '100%', borderRadius: '10px', overflow: 'hidden' }}>
          <Button
            onClick={() => navigate('/inspection-booking')}
            sx={{
              width: '100%',
              background: 'linear-gradient(to right, #F1761B, #FF5100)',
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 700,
              borderRadius: '10px',
              paddingY: '12px',
              letterSpacing: '1px',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              '&:hover': {
                background: 'linear-gradient(to right, #e0651b, #e94600)',
              },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontWeight="700" fontSize="16px">
                Book FOCUS Certified Inspection!
              </Typography>
              <Typography fontSize="10px" fontWeight="400">
                Inspection team will contact you soon.{' '}
              </Typography>
            </Box>
          </Button>
          <Box
            sx={{
              height: '15px',
              backgroundColor: '#c5550e',
              marginTop: '-10px',
              borderBottomLeftRadius: '10px',
              borderBottomRightRadius: '10px',
            }}
          />
        </Box>
      </Stack>
    </>
  );
}

export default InspectCarBanner;
